<div class="sem-acesso-page">
  <div class="sem-acesso-card">
    <div class="icon-wrapper">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
        <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11H10V7H14V11H12ZM12 15H10V13H14V15H12Z" fill="currentColor"/>
      </svg>
    </div>

    <h1>Acesso não autorizado</h1>

    <p>
      Sua identidade foi autenticada no SSO (Keycloak), mas ainda não está cadastrada neste sistema.
    </p>

    <p class="instrucao">
      Entre em contato com o administrador do sistema para solicitar o seu acesso.
    </p>

    <button type="button" class="btn-sair" (click)="logout()">
      Sair
    </button>
  </div>
</div>
